/**
 * Main header navigation component for the BUIHA website.
 */
import React, { useState } from "react";
import GBS from "./GBS";
import Development from "./Education";
import Competition from "./Games";
import Clubs from "./Clubs";
import MainLogo from "./MainLogo";
import { BrowserRouter as Router, Link } from "react-router-dom";
import { DropdownProvider } from "./DropdownContext";
import DropdownMenu from "./DropdownMenu";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
import MobileDropdownMenu from "./MobileDropdownMenu";
import MobileClubsDropdownMenu from "./MobileClubsDropdownMenu";
import MobileGamesDropdownMenu from "./MobileGamesDropdownMenu";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import SocialsLinks from "./SocialsLinks";

const infoContent = [
  // { to: "/contact", label: "Contact Us", external: true },
  /*{ to: "/camps", label: "Training Camps", external: false },*/
  {
    to: "https://buiha.org.uk/legacy/rulebook.html",
    label: "Rulebook 25/26",
    external: true,
  },
  {
    to: "https://buiha.org.uk/legacy/discipline.html",
    label: "Discipline",
    external: true,
  },
  {
    to: "https://buiha.org.uk/legacy/conduct.html",
    label: "Code of Conduct",
    external: true,
  },
  {
    to: "https://buiha.org.uk/legacy/procedure.html",
    label: "Game Day Procedure",
    external: true,
  },
  {
    to: "https://forms.office.com/e/nYAMzuh4q6",
    label: "Injury Report Form",
    external: true,
  }
];

const moreContent = [
  // { to: "/history",
  //   label: "BUIHA History",
  //   external: false
  // },
  {
    to: "https://forms.office.com/e/NPayzK9rNn",
    label: "Web Feedback",
    external: true,
  },
  {
    to: "https://www.youtube.com/c/BUIHAStream/live",
    label: "BUIHA Live",
    external: true,
  },
  {
    to: "https://buihainfo.substack.com/",
    label: "BUIHA Podcast",
    external: true,
  },
  {
    to: "https://gamesheet.buiha.org.uk",
    label: "Gamesheet OGM",
    external: true,
  },
  // { to: "/merchandise",
  //   label: "Nationals Merch",
  //   external: false
  // }

];

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // State for mobile menu

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    if (isMobileMenuOpen) {
      setShowMenu(true);
    } else {
      // Wait for the transition to complete before hiding the menu
      const timer = setTimeout(() => setShowMenu(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isMobileMenuOpen]);

  return (
    <div className="header bg-light-1 topbar flex flex-row justify-between items-center w-full dark:bg-dark-1">
      {/* BUIHA logo */}
      <MainLogo />

      <div className="max-lg:hidden">
        <DropdownProvider>
          <nav>
            <ul className="flex flex-row justify-center items-center">
              <Clubs id="clubs" />
              <Competition id="competition" />
              <Development />
              {/*<GBS />*/}
              <DropdownMenu
                id="info"
                title="Info"
                width="w-64"
                offset="-ml-40"
                links={infoContent}
              />
              <DropdownMenu
                id="more"
                title="More"
                width="w-56"
                offset="-ml-28"
                links={moreContent}
              />
            </ul>
          </nav>
        </DropdownProvider>
      </div>

      {/* Social media logos */}
      <div className="hidden xl:flex socials flex-row justify-end items-center w-44 min-w-44">
        <SocialsLinks />
      </div>

      {/* Mobile Menu */}
      <div className="mobile-menu flex lg:hidden flex-row justify-end items-center w-44 min-w-44">
        <button
          onClick={toggleMobileMenu}
          className="text-3xl p-2 focus:outline-none"
        >
          {isMobileMenuOpen ? <HiOutlineX /> : <HiOutlineMenu />}
        </button>
      </div>

      {/* Mobile Dropdown */}

        <div
      className={`lg:hidden absolute top-[52px] left-0 w-full bg-light-1 shadow-lg z-50 ${
        isMobileMenuOpen ? 'fade-enter fade-enter-active' : 'fade-exit fade-exit-active'
      } ${!showMenu ? 'hidden' : ''}`}
    >
          <nav>
            <ul className="flex flex-col bg-light-1 dark:bg-dark-1 border-b-2 dark:border-dark-3">
              {/* Mobile-specific Dropdowns */}
              <li>
                <MobileClubsDropdownMenu
                  title="Clubs"
                  closeMenu={toggleMobileMenu}
                />
              </li>
              <li>
                <MobileGamesDropdownMenu
                  closeMenu={toggleMobileMenu}
                />
              </li>
              <li>
                <Link
                  to="/education"
                  className="text-sm block py-[6px] pl-2 xs:pl-[12px] bg-light-2 dark:bg-dark-1 h-[36px]"
                  onClick={toggleMobileMenu}
                >
                  Education
                </Link>
              </li>
              {/*
              <li>
                <Link
                  to="/gbs"
                  className="text-sm block py-1 pl-2 xs:pl-[12px] bg-light-2 dark:bg-dark-1"
                  onClick={toggleMobileMenu}
                >
                  GBS
                </Link>
              </li>
              */}
              <li>
                <MobileDropdownMenu
                  id="info"
                  title="Info"
                  links={infoContent}
                  closeMenu={toggleMobileMenu}
                />
              </li>
              <li>
                <MobileDropdownMenu
                  id="more"
                  title="More"
                  links={moreContent}
                  closeMenu={toggleMobileMenu}
                />
              </li>
            </ul>
          </nav>
        </div>
      
    </div>
  );
};

export default Header;
